import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const SHORTCUTS = [
  { key: "g", path: "/", label: "All Apps" },
  { key: "d", path: "/dashboard", label: "Dashboard" },
  { key: "s", path: "/sales", label: "Sales" },
  { key: "u", path: "/purchase", label: "Purchase" },
  { key: "p", path: "/production", label: "Production" },
  { key: "i", path: "/inventory", label: "Inventory" },
  { key: "q", path: "/quality", label: "Quality" },
  { key: "f", path: "/finance", label: "Finance" },
  { key: "h", path: "/hr", label: "HR" },
  { key: "r", path: "/reports", label: "Reports" },
  { key: "m", path: "/masters", label: "Master Data" },
  { key: "t", path: "/tasks", label: "Tasks" },
  { key: "a", path: "/approvals", label: "Approvals" },
];

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const [showHelp, setShowHelp] = useState(false);

  const handleKeyDown = useCallback((e) => {
    if (!e.altKey) return;
    // Don't trigger inside inputs/textareas
    const tag = e.target.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || e.target.isContentEditable) return;

    if (e.key === "?" || e.key === "k" || e.key === "K") {
      e.preventDefault();
      setShowHelp(prev => !prev);
      return;
    }

    const shortcut = SHORTCUTS.find(s => s.key === e.key.toLowerCase());
    if (shortcut) {
      e.preventDefault();
      navigate(shortcut.path);
    }
  }, [navigate]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return { showHelp, setShowHelp, SHORTCUTS };
}
